import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid, Icon } from "semantic-ui-react";
import "./Module5.scss";

const virtualScenesController = new VirtualScenes();

export function Module5({ refId }) {
  const module5 = "module_05";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [imageCompetencyUrl, setImageCompetencyUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Obtener datos del módulo
  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module5
      );
      setModuleData(data.moduleData);

      // Obtener URL de la imagen si existe
      if (data.moduleData?.ModFiveImagecompetencies) {
        const imageData = await virtualScenesController.getRepoScene(
          data.moduleData.ModFiveImagecompetencies,
          accessToken
        );
        setImageCompetencyUrl(imageData.url);
      }
    } catch (err) {
      console.error("Error al obtener datos del módulo:", err);
      setError("Error al cargar el módulo");
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module5]);

  // ✅ Llamada inicial
  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="module5-container">
      <h2>Competencias Clave</h2>
      <Grid stackable columns={2} className="module5-content">
        {/* Columna Izquierda - Imagen */}
        <Grid.Column width={8} className="module5-image">
          {imageCompetencyUrl ? (
            <img src={imageCompetencyUrl} alt="Competencias Clave" />
          ) : (
            <div className="image-placeholder">Imagen no disponible</div>
          )}
        </Grid.Column>

        {/* Columna Derecha - Contenido */}
        <Grid.Column width={6} className="module5-competencies">
          {moduleData?.ModFiveCompetencies?.map((competency) => (
            <div key={competency._id} className="competency-item">
              <h4>
                {competency.title}
              </h4>
              {/* Renderizar descripción como HTML */}
              <p
                dangerouslySetInnerHTML={{
                  __html: competency.description || "",
                }}
              />
            </div>
          ))}
        </Grid.Column>
      </Grid>
    </div>
  );
}
